import { useEffect, useState } from 'react';

export function useUpdateBadge() {
  const [waitingWorker, setWaitingWorker] = useState<ServiceWorker | null>(null);
  const [show, setShow] = useState(false);
  useEffect(() => {
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.addEventListener('controllerchange', () => window.location.reload());
      navigator.serviceWorker.register('/sw.js').then((reg) => {
        if (reg.waiting) { setWaitingWorker(reg.waiting); setShow(true); }
        reg.addEventListener('updatefound', () => {
          const ww = reg.installing; if (!ww) return;
          ww.addEventListener('statechange', () => {
            if (ww.state === 'installed' && navigator.serviceWorker.controller) { setWaitingWorker(reg.waiting || ww); setShow(true); }
          });
        });
      }).catch(() => void 0);
    }
  }, []);
  const applyUpdate = () => { waitingWorker?.postMessage({ type: 'SKIP_WAITING' }); };
  return { show, applyUpdate };
}
